import defaultTenant from "@irati/identity/helpers/defaultTenant";
import { defaultFlags } from "./featureFlags";
var defaultAuth = {
    userTenant: defaultTenant,
    featureFlags: defaultFlags(),
    apps: {},
    isSSO: false
};
export default defaultAuth;
